import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { cn } from '@/lib/utils'

/**
 * Texto em markdown: negrito, listas, tabelas, links (abrem em outra aba),
 * código. Fórmulas (KaTeX) não são desenhadas, para o `$` de um valor em dinheiro
 * não virar fórmula por engano. HTML cru no texto não é interpretado.
 */
function Markdown({ children, className }: { children: string; className?: string }) {
  return (
    <div
      data-slot="markdown"
      className={cn('flex flex-col gap-2 text-sm leading-relaxed', className)}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node: _n, ...p }) => (
            <a
              {...p}
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground underline underline-offset-4"
            />
          ),
          code: ({ node: _n, className: c, ...p }) => (
            <code {...p} className={cn('rounded bg-muted px-1 py-0.5 font-mono text-xs', c)} />
          ),
          ul: ({ node: _n, ...p }) => <ul {...p} className="list-disc pl-5" />,
          ol: ({ node: _n, ...p }) => <ol {...p} className="list-decimal pl-5" />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  )
}

export { Markdown }
